<template>
    <div>
        <product-list-component :application="true" :admin-super="adminSuper == 1 ? true : false"></product-list-component>
    </div>
</template>
<script>
import ProductListComponent from '@/components/ProductListComponent.vue';
import { API, doGet, doPost } from "@/api/api.js"

export default {
    data: function () {
        return {
            adminSuper: 0
        }
    },
    methods: {
        
    },
    components: {
        "product-list-component": ProductListComponent
    },
    created: async function() {
        this.adminSuper = await doGet(API.ADMIN_SUPER);
    }
}
</script>
<style scoped lang="less">

</style>